// ----- GenreAndForm references ------------------------------------------------------------
/**
 * A term should list uri for itself and all children, to support testing
 * on higer levels in the hierarchy.
 */
export const GenreAndFormRef = {
  ['Lærebøker']: [
    'https://id.nb.no/vocabulary/ntsf/184',
    'https://id.nb.no/vocabulary/ntsf/1882',
    'https://id.nb.no/vocabulary/ntsf/170',
    'https://id.nb.no/vocabulary/ntsf/434',
  ],
  ['Biographies']: [
    'https://id.nb.no/vocabulary/ntsf/36', // Biografier
    'https://id.nb.no/vocabulary/ntsf/227', // Personlige beretninger
    'https://id.nb.no/vocabulary/ntsf/272', // Selvbiografier
  ],
} as const;
